import jStat from 'jstat';
import sum from 'lodash/sum';
import find from 'lodash/find';
import { round6 } from 'utilities/math';

export const calculateTableDataForChiSquareGoodnessOfFit = (dataset, parameter, info, formCategoriesInfo) => {
  let expected = [];
  const data = find(dataset, parameter)[parameter];
  const n = data.count;
  const observed = data.levels;
  const levelNames = observed.map(item => item.name);
  const observedCount = observed.map(item => item.count);
  if (info.length) {
    expected = info.map(item => round6(item * n));
  } else if (formCategoriesInfo) {
    expected = Object.values(formCategoriesInfo);
  } else {
    const proportion = 1 / observed.length;
    expected = data.levels.map(() => round6(proportion * n));
  }
  const contributionChiSquare = observed.map((item, i) =>
    (item.count - expected[i]) ** 2 / expected[i]
  );
  return ({
    expected,
    levelNames,
    observedCount,
    contributionChiSquare,
    categoryName: parameter
  });
};

export const calculateChiSquareGoodnessOfFitSummary = (dataSet, parameter, chiSquareArray) => {
  const data = find(dataSet, parameter)[parameter];
  const n = data.count;
  const df = data.levels.length - 1;
  const chiSquare = round6(sum(chiSquareArray));
  let pValue = round6(1 - jStat.chisquare.cdf(chiSquare, df));
  if (!pValue) {
    pValue = '< 0.00001';
  }
  return ({
    n,
    df,
    pValue,
    chiSquare
  });
};
